import { Helmet } from "react-helmet";
import NucleusCtaSection from "./components/NucleusCtaSection";
import NucleusHeaderSection from "./components/NucleusHeaderSection";
import NucleusInfrastructureSection from "./components/NucleusInfrastructureSection";
import NucleusLearningAreasSection from "./components/NucleusLearningAreasSection";
import NucleusModelSection from "./components/NucleusModelSection";
import NucleusStatsSection from "./components/NucleusStatsSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Nucleus = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | The Nucleus</title>
      </Helmet>

      <NucleusHeaderSection />

      <NucleusStatsSection />

      <NucleusModelSection />

      <NucleusInfrastructureSection />

      <NucleusLearningAreasSection />

      <NucleusCtaSection />

      <SiteFooter />
    </div>
  );
};

export default Nucleus;
